export class Imagen {
    constructor(
        public url: string,

    ) { }

}